var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.273 9.34h-3.02a.667.667 0 100 1.333h1.6A5.334 5.334 0 011.666 7 .667.667 0 10.333 7a6.667 6.667 0 0011.253 4.82V13a.667.667 0 001.334 0v-3a.667.667 0 00-.647-.66zM7 .333A6.667 6.667 0 002.413 2.18V1A.667.667 0 001.08 1v3a.667.667 0 00.666.667h3a.667.667 0 000-1.334h-1.6A5.333 5.333 0 0112.333 7a.666.666 0 101.333 0A6.667 6.667 0 007 .333z",
    fill: "#fff"
  })));
}
export default SvgRefresh;